import "@/components/site/Footer.css";

const EMAIL = "shvetha@orani.studio";

export default function Footer() {
  return (
    <footer
      className="site-footer"
      data-testid="footer-section"
      aria-label="Studio signature"
    >
      <span className="site-footer__rule" aria-hidden="true" />

      <div className="site-footer__row">
        <div className="site-footer__group site-footer__group--identity">
          <p className="site-footer__copy" data-testid="footer-copyright">
            © 2026 Ōraṇi
          </p>
          <p className="site-footer__address" data-testid="footer-address">
            Jayanagar, Bangalore, India
          </p>
        </div>

        <div className="site-footer__group site-footer__group--email">
          <a
            href={`mailto:${EMAIL}`}
            className="site-footer__email"
            data-testid="footer-email"
          >
            {EMAIL}
          </a>
        </div>
      </div>
    </footer>
  );
}
